export default function Teams() {
  return (
    <img
      src="https://static1.cbrimages.com/wordpress/wp-content/uploads/2018/08/jake-the-dog-pure-css-adventure-time-wallpaper-by-sangreprimitiva-d5vs51f.jpg"
      alt="Jake"
      className="object-cover h-[calc(100vh-122px)] w-full"
    />
  );
}
